// extracted by mini-css-extract-plugin
export default {"shadow":"count-completed_shadow__zImeC"};